import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { AudienceCountsTable } from '../audienceCountsTable';
import { PieChart } from '../audienceCountsTable/PieChart';
import { InsightPanel } from '../insightPanel/InsightPanel';
import { AudienceMeterChart } from './AudienceMeterChart';
import { EmptyData } from '../insightEmptyData';
import { AUDIENCE_INSIGHTS_METER_FEATURE_FLAG } from '../../../constants';
import { AudienceCount, InsightType } from '../../../types';

type InsightTableProps = {
  title: string;
  isEnabled: boolean;
  message?: string;
  type?: InsightType;
  hasChart?: boolean;
  values?: AudienceCount[];
  isLoading?: boolean;
  showDivider?: boolean;
};

export const InsightTable = ({
  title,
  isEnabled,
  values,
  type,
  hasChart = false,
  isLoading = false,
  showDivider = false,
}: InsightTableProps) => {
  const isMeterUIEnabled = useFeatureFlag(AUDIENCE_INSIGHTS_METER_FEATURE_FLAG);

  const isChartEnabled = hasChart && !!values?.length;
  const isMeterChartEnabled = isChartEnabled && isMeterUIEnabled;
  const isPieChartEnabled = isChartEnabled && !isMeterUIEnabled;

  return isEnabled && values ? (
    <InsightPanel title={title} type={type} showDivider={showDivider}>
      <AudienceMeterChart
        audienceCounts={values}
        isLoading={isLoading}
        isEnabled={isMeterChartEnabled}
      />
      <PieChart
        audienceCounts={values}
        isLoading={isLoading}
        hasChart={hasChart}
        isEnabled={isPieChartEnabled}
      />
      <AudienceCountsTable values={values} isLoading={isLoading} hasChart={hasChart} />
    </InsightPanel>
  ) : (
    <InsightPanel type={type} title={title}>
      <EmptyData type={type} />
    </InsightPanel>
  );
};
